import { Avatar, Button, Stack, Typography, useTheme } from '@mui/material';
import React from 'react'
import { StandardTableActions } from '../../../Components/StandardTableActions/StandardTableActions';
import { DataTable } from '../../../Components/Table/DataTable';
import { IDataTableProps, MobileLogoRenderType, RenderType } from '../../../Components/Table/interfaces/IDataTableProps';
import { useAppSelector, IStoreState, useAppDispatch } from '../../../redux';
import PageContainer from '../../../Components/PageContainer/PageContainer';
import { CustomButton } from '../../../Components/CustomButton';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { MARKETING_COUPON_CODES_ROUTE } from '../Marketing.constants';
import { ICoupon, clearCouponsStateSync, fetchAllCouponsListAsync } from '../../../redux/marketing/coupon-codes';
import { useOutletContext } from '../../../providers';
import { StandardCard } from '../../../Components/Card/StandardCard';

export const CouponCodesTable = () => {
     const { outlet_details: { outlet_uuid } } = useOutletContext();
    const {
        data: couponCodesData,
        loading,
    } = useAppSelector((storeState: IStoreState) => storeState.marketing.coupons.coupons_list);
    const dispatch = useAppDispatch();
    const navigate = useNavigate()

    const [pagination, setPagination] = React.useState({
        pageNumber: 1,
        rowsPerPage: 10,
    });


    const dataTableProps: IDataTableProps = {
        isPagination: true,
        rowsPerPageOptions: 25,
        isDataLoading: false,
        mobileLogo: {
            type: MobileLogoRenderType.reactNode,
            onMobileLogoRender: (data: any) => {
                return (
                    <Avatar
                        sx={{
                            width: 45,
                            height: 45,
                            color: "#fff",
                            ml: "-8px",
                            mr: 2,
                        }}
                    ></Avatar>
                );
            },
        },

        columns: [
            {
                key: "view",
                headerName: "Actions",
                fieldName: "",
                headingAlign: "center",
                renderType: RenderType.CUSTOM_RENDER,
                onRowCellRender: (value, row: ICoupon) => {
                    return (
                        <StandardTableActions
                            onEditClick={() => navigate(`${MARKETING_COUPON_CODES_ROUTE}/manage/${row.coupon_uuid}`)}
                        />
                    );
                },
            },
            {
                key: "coupon_code",
                headerName: "Coupon Code",
                fieldName: "coupon_code",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },
            {
                key: "discount_type",
                headerName: "Discount Type",
                fieldName: "discount_type",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },
            {
                key: "coupon_amount",
                headerName: "Coupon Amount",
                fieldName: "coupon_amount",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },

            {
                key: "minimum_spend",
                headerName: "Minimum Spend",
                fieldName: "minimum_spend",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },
            {
                key: "maximum_spend",
                headerName: "Maximum Spend",
                fieldName: "maximum_spend",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },
            {
                key: "coupon_expiry_date",
                headerName: "Coupon Expiry Date",
                fieldName: "coupon_expiry_date",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
                onRowCellRender: (values, row: ICoupon) => {
                    return moment(row.coupon_expiry_date).isValid() ? moment(row.coupon_expiry_date).format("DD-MM-YYYY") : "--";
                },
            },

        ],

        items: couponCodesData,
        onPageChange: (newPageNumber: number) => {
            setPagination({ ...pagination, pageNumber: newPageNumber });
        },
        onRowsPerPageChange: (pageNumber: number, rowsPerPage: number) => {
            setPagination({
                pageNumber: pageNumber,
                rowsPerPage: rowsPerPage,
            });
        },
    };


    React.useEffect(() => {
        if(outlet_uuid)
        dispatch(
            fetchAllCouponsListAsync({
                outlet_uuid,
                page: pagination.pageNumber,
                rowsPerPage: pagination.rowsPerPage,
            }),
        );
    }, [pagination, outlet_uuid]);

    React.useEffect(() => {
        return () => {
            dispatch(clearCouponsStateSync());
        };
    }, []);

    const isLightMode = useTheme().palette.mode === "light";

    return (
        <PageContainer title="Coupons" description='inner page' >


            <StandardCard
                heading="Coupons"
                rightHeading={
                    <CustomButton
                        variant="outlined"
                        sx={{
                            display: "flex",
                            marginLeft: "auto",
                            marginY: 2,
                            minWidth: "80px !important",
                            backgroundColor: isLightMode
                              ? "var(--secondary-color)"
                              : "var(--primary-color)",
                            color: isLightMode
                              ? "var(--text-light-color)"
                              : "var(--text-dark-color)",
                            border: isLightMode
                              ? "var(--border-light-color) 1px solid"
                              : "var(--border-dark-color) 1px solid",
                            "&:hover": {
                              backgroundColor: isLightMode
                                ? "var(--secondary-color)"
                                : "var(--tertiary-color)",
                              opacity: isLightMode ? 0.85 : 1,
                              // color: isLightMode ? "var(--primary-color)" : "var(--secondary-color)",
                              border: isLightMode
                                ? "var(--border-light-color) 1px solid"
                                : "var(--border-dark-color) 1px solid",
                            },
                          }}
                        onClick={() => navigate(`${MARKETING_COUPON_CODES_ROUTE}/manage`)}
                    >
                        Add New Coupon
                    </CustomButton>
                }
            >
 <DataTable {...dataTableProps} />
            </StandardCard>
            {/* <Stack direction="row" justifyContent="space-between" alignItems="center" my={2} >
                <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
                    <Typography variant='h2'>Coupons</Typography>
                </Stack>
                <CustomButton
                    variant="contained"
                    color="primary"
                    sx={{
                        display: "flex",
                        marginLeft: "auto",
                    }}
                    onClick={() => navigate(`${MARKETING_COUPON_CODES_ROUTE}/manage`)}
                >
                    Add New Coupon
                </CustomButton>
            </Stack> */}
           
        </PageContainer>
    );
}
